import { create } from "zustand";
import {
  createCoreStreamingSlice,
  CoreStreamingSlice,
} from "./CoreStreamingSlice";
import {
  createMessageParserSlice,
  MessageParserSlice,
} from "./MessageParserStore";
import { createArtifactSlice, ArtifactSlice } from "./ArtifactSlice";
import { ChatConfiguration } from "../types";
import { subscribeWithSelector } from "zustand/middleware";

export type StreamingState = CoreStreamingSlice &
  MessageParserSlice &
  ArtifactSlice;

/** What a descendant may see of the host's stream: everything but config. */
export type ChatStreamState = Omit<StreamingState, "setStreamConfig">;

/**
 * A descendant's handle on the host's store: read, subscribe, act. No
 * setState and no setStreamConfig — only owner hooks write config. Type-level
 * only: any StoreApi<StreamingState> is assignable to it.
 */
export interface ChatStreamStore {
  getState: () => ChatStreamState;
  subscribe: (
    listener: (state: ChatStreamState, prev: ChatStreamState) => void,
  ) => () => void;
}

export const createStreamingStore = (initialConfig: ChatConfiguration = {}) =>
  create<StreamingState>()(
    subscribeWithSelector((set, get, api) => ({
      ...createCoreStreamingSlice(initialConfig)(set, get, api),
      ...createMessageParserSlice(set, get, api),
      ...createArtifactSlice(set, get, api),
    })),
  );
